<template>
	<header :class="[{'dark-blue-mode' : $route.meta.headerColor === 'dark'}]">
		<div class="navigation-colum logo-section" @click="toggleSideMenu">
			<div class="sidemenu-controls">
				<div class="mod burger">
					<div class="menu" ref="burger">
						<div :class="['bar', {'dark-blue-mode' : $route.meta.headerColor === 'dark'}]"></div>
						<div :class="['bar', {'dark-blue-mode' : $route.meta.headerColor === 'dark'}]"></div>
						<div :class="['bar', {'dark-blue-mode' : $route.meta.headerColor === 'dark'}]"> </div>
					</div>
				</div>
			</div>
		</div>

		<div class="header-wrapper">
			<div class="logo-container">
				<router-link
					v-if="$route.path !== '/landing'"
					class="logo"
					tag="div"
					:to="`${!$route.fullPath.includes('/gop/') ? '/home' : '/gop/home'}`"
				>
					<img
						v-if="!$route.fullPath.includes('/gop/')"
						:src="$route.meta.headerColor === 'dark'
							? require('@/drc/assets/images/dark-mode-logo.svg')
							: require('@/common/assets/icons/drc-logo.svg')"
						alt="Akkodis"
					>
					<img v-else :src="require('@/common/assets/icons/gop-logo.svg')" alt="GOP">
				</router-link>
				<div v-else class="logo akkodis-logo">
					<img :src="require('@/common/assets/icons/akkodis-brand-logo.svg')" alt="Akkodis">
				</div>
			</div>
			<HeaderGlobalSearch :latestProjects="latestProjects" />

			<div class="language-and-profile-container">
				<ApplicationLanguageDropdown v-if="showLanguageOptions" />
				<UserProfile />
			</div>
		</div>

	</header>
</template>
<script>
import {EventSideMenu} from "@/common/configurations/event-bus.js";
import { EventStepFrom } from "@/common/configurations/event-bus.js";
import { PAGE_NAME } from "@/common/utils/constants.js";
import ApplicationLanguageDropdown from "@/common/components/ApplicationLanguageDropdown";
import UserProfile from "@/common/components/UserProfile";
import HeaderGlobalSearch from "@/common/components/HeaderGlobalSearch";
import {getTop6} from "@/drc/services/global-search-service";

	export default {
		name: "Header",
		components: {
			ApplicationLanguageDropdown,
			UserProfile,
			HeaderGlobalSearch
		},
		data() {
			return {
				mobileMod: false,
				guideStatus: false,
				guideAllowedRoutes: [
					"submission-continue-draft-project",
					"submission-new-project-form"
				],
				latestProjects: []
			}
		},
		methods: {
			getLatestProjects() {
				getTop6(6, this.$i18n.locale)
					.then((response) => {
						if (response.error) {
							console.error(response.error)
						} else {
							this.latestProjects = response.payload;
						}
					});
			},
			toggleSideMenu() {
				this.$refs.burger.classList.toggle('active');
				EventSideMenu.$emit("toggle-sidemenu");
			},
			toggleBurgerLogo() {
				this.$refs.burger.classList.toggle('active');
			},
			closeBurgerLogo() {
				this.$refs.burger.classList.remove('active');
			},
			toggleStepFormGuide() {
				this.guideStatus = !this.guideStatus;
				EventStepFrom.$emit("toggleMobileGuide", this.guideStatus);
			}
		},
		computed: {
			showLanguageOptions() {
				let mode = this.$route.query.mode;
				let preview = this.$route.query.preview;
				let initialSubmissionPreview = this.$route.query['initial-submission-preview'];

				let allowedForViewPaths = [
					`${PAGE_NAME.manage}/${PAGE_NAME.content}`,
					`${PAGE_NAME.manage}_${PAGE_NAME.content}_${PAGE_NAME.update}`
				];

				return !(allowedForViewPaths.includes(this.$route.name) || mode || preview || initialSubmissionPreview);
			}
		},
		mounted() {
			this.getLatestProjects();
			if (window.innerWidth <= 768) {
				this.mobileMod = true;
			}
		},
		created() {
			EventSideMenu.$on("toggle-burger-logo", this.toggleBurgerLogo);
			EventSideMenu.$on("close-burger-logo", this.closeBurgerLogo);
		},
		destroyed() {
			EventSideMenu.$off("toggle-burger-logo");
			EventSideMenu.$off("close-burger-logo");
		}
	}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

header {
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 10px 40px;
	height: 65px;
	box-shadow: 1px 2px 5px 0 rgba(0,0,0,0.1);
	position: relative;
	background: #ffffff;
	z-index: 102;
	gap: 25px;
	align-items: center;

	@media (max-width: 800px) {
		gap: 10px;
		padding: 10px 15px;
	}

	.navigation-colum {
		width: fit-content;
		min-width: 30px;
		padding-top: 5px;
		padding-bottom: 5px;
		padding-right: 15px;
		cursor: pointer;
	}

	.header-wrapper {
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		width: 100%;
		justify-content: space-between;
		gap: 25px;
		align-items: center;
		margin: 0 auto;
		height: 40px;

		@media (max-width: 800px) {
			gap: 15px;
			justify-content: flex-end;
		}

		.logo-container {
			.logo {
				cursor: pointer;

				img {
					min-width: 240px;
					max-height: 30px;

					@media (max-width: 800px) {
						display: none;
					}
				}
			}
		}

		.language-and-profile-container {
			display: flex;
			flex-direction: row;
			flex-wrap: nowrap;
			gap: 10px;
			justify-content: space-between;
			align-items: center;

			@media (max-width: $mobile) {
				margin-right: 0;
				gap: 15px;

				.custom-dropdown {
					margin-right: 0;
				}
			}
		}

	}

	&.dark-blue-mode {
		background: #001F33;
		border-bottom: 1px solid #FFFFFF2E;
	}

	&.global-search-view {
		.global-search-input-container {
			.test {
				display: inline-block;
			}
		}
	}

}
</style>

<style lang="scss">
.global-search-view {
	.custom-dropdown {
		.dropdown-list {
			top: 45px;
			z-index: 4;
		}
	}
}
</style>

<style lang="sass">
.menu
	position: relative
	cursor: pointer

.bar
	height: 3px
	width: 30px
	display: block
	margin: 5px auto
	position: relative
	background-color: #0e2b40
	-moz-transition: 0.4s
	-o-transition: 0.4s
	-webkit-transition: 0.4s
	transition: 0.4s

	&.dark-blue-mode
		background-color: white

.burger .bar:nth-of-type(1)
	-moz-animation: rotateR 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)
	-webkit-animation: rotateR 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)
	animation: rotateR 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)

.burger .bar:nth-of-type(2)
	-moz-animation: fade 1.5s cubic-bezier(0.1, 0.8, 0.1, 1)
	-webkit-animation: fade 1.5s cubic-bezier(0.1, 0.8, 0.1, 1)
	animation: fade 1.5s cubic-bezier(0.1, 0.8, 0.1, 1)

.burger .bar:nth-of-type(3)
	-moz-animation: rotateL 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)
	-webkit-animation: rotateL 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)
	animation: rotateL 1.5s cubic-bezier(0.5, 0.2, 0.2, 1)


.burger .menu.active .bar:nth-of-type(1)
	-moz-transform: translateY(6px) rotate(45deg)
	-ms-transform: translateY(6px) rotate(45deg)
	-webkit-transform: translateY(6px) rotate(45deg)
	transform: translateY(6px) rotate(45deg)

.burger .menu.active .bar:nth-of-type(2)
	opacity: 0

.burger .menu.active .bar:nth-of-type(3)
	-moz-transform: translateY(-10px) rotate(-45deg)
	-ms-transform: translateY(-10px) rotate(-45deg)
	-webkit-transform: translateY(-10px) rotate(-45deg)
	transform: translateY(-10px) rotate(-45deg)

</style>
